import { V2Question } from "../helper";

// A single cell's value, normalised like the rest of the v2 form layer.
export type CellValue = string | number | string[] | null;

// One learner = one grid row.
export interface Learner {
  userId: string;
  userType?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

// answers[learnerId][questionId] = value
export type GridAnswers = Record<string, Record<string, CellValue>>;

// Per-learner submission status from the server prefill (SUBMITTED rows are locked).
export type LearnerStatusMap = Record<string, string | null>;

export interface TabularData {
  loading: boolean;
  error: string | null;
  formId: string;
  formTitle: string;
  formType?: string;
  // Pre-migration form id; drives legacy SESSION_FEEDBACK /10 scoring.
  legacyId?: string | null;
  questions: V2Question[];
  learners: Learner[];
  // Server-side prefill merged with any locally-cached draft.
  initialAnswers: GridAnswers;
  statusByLearner: LearnerStatusMap;
}

// A grid coordinate. `row` indexes learners, `col` indexes questions.
export interface CellCoord {
  row: number;
  col: number;
}

export const displayName = (learner: Learner): string => {
  const name = `${learner.firstName || ""} ${learner.lastName || ""}`.trim();
  return name || learner.email || "Learner";
};
